import { useEffect, useState } from "react";

import { useAppDispatch } from "../redux/hooks";
import { saveUser, useGetUser } from "../redux/slices";

export const useCheckProducts = () => {
  const [hasFastDraw, setHasFastDraw] = useState(true);
  const { user, isLoading } = useGetUser();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const hasFastDrawScope = user?.scopes?.includes("fd_web");

    if (hasFastDrawScope) {
      // check if fast draw is expired
      const fastDrawProductExpiration = user?.products?.FASTDRAW2?.[0]?.expires;
      // check if expiration is in the past
      const isExpired = fastDrawProductExpiration ? new Date(fastDrawProductExpiration) < new Date() : true;
      if (isExpired) setHasFastDraw(false); // user has fast draw scope but it is expired
      else {
        setHasFastDraw(true);
        dispatch(saveUser(user));
      }
    } else {
      setHasFastDraw(false); // user does not have fast draw scope
    }
  }, [dispatch, user]);

  return { hasFastDraw, loading: isLoading };
};
